<template>
    <div class="card">
        <div class="card-body">
            <h4 class="title text-primary mb-0">{{ __('Institution Level') }}</h4>
            <template v-if="loading">
                <Spinner spinner-type="grow" />
            </template>
            <template v-else>
                <div id="institition_type_render_div">
                    <Chart v-if="chartConfig" :options="chartConfig" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Spinner from '../../components/Spinner';
import { Chart } from 'highcharts-vue';

export default {
    components: {
        Spinner,
        Chart,
    },

    inject: ['selectedStatsWheelPath'],

    data() {
        return {
            loading: false,
            chartConfig: null,
        }
    },

    watch: {
        selectedStatsWheelPath: function (value) {
            if (value === 'Ambassador') {
                this.fetchCounts({ ambassador: true });
            } else if (value === 'Teacher') {
                this.fetchCounts();
            }
        },
    },

    mounted() {
        this.observe_visibility(this.$el, () => {
            this.fetchCounts();
        });
    },

    methods: {
        fetchCounts(params = {}) {
            this.loading = true;
            axios.get('/dashboard/institution-type-wise-user-count', { params })
                .then(({ data }) => {
                    const counts = data.counts.map(obj => ([
                        this.locale_attr(obj, 'type_{lang}_name'),
                        obj.user_count,
                    ]));

                    this.initChart([{ data: counts }]);
                })
                .catch(console.error)
                .finally(() => this.loading = false);
        },

        initChart(series) {
            const vm = this;
            this.chartConfig = {
                chart: {
                    type: 'pie',
                    height: '330px',
                    events: {
                        render: function () {
                            if (this.series.length !== 0) {
                                let total = 0;
                                this.series[0].data.forEach(item => {
                                    total += item.visible ? item.y : 0;
                                });

                                this.setTitle({
                                    text: `<span style="font-size: 24px">${vm.en_to_bn(total)}</span><br>
                                    <span style="font-size: 20px">${vm.__('Overall')}</span>`,
                                });
                            }
                        }
                    }
                },
                title: {
                    verticalAlign: 'middle',
                    floating: true,
                    y: 5,
                },
                legend: {
                    enabled: true,
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        colorByPoint: true,
                        type: 'pie',
                        size: '100%',
                        innerSize: '50%',
                        showInLegend: true,
                        dataLabels: {
                            enabled: false,
                        },
                    },
                },
                tooltip: {
                    formatter: function () {
                        return '<b>' + this.point.name + '</b>: ' + vm.en_to_bn(this.y);
                    },
                },
                colors: ['#996DC0', '#88BF4D', '#F9D45C'], // 4th color: #F2A86F
                series,
                credits: {
                    enabled: false,
                },
                accessibility: {
                    enabled: false,
                },
            };
        },
    },
}
</script>